(function(){
  'use strict';

  if(window.__STWL_LEMON_CHECKOUT_TRACKING__) return;
  window.__STWL_LEMON_CHECKOUT_TRACKING__ = true;

  function cleanOfferName(link){
    var explicit = String(link.getAttribute('data-stwl-item-name') || '').trim();
    if(explicit) return explicit.slice(0, 100);
    return String(link.textContent || 'Digital Product')
      .replace(/^\s*(unlock|choose|buy|get)\s+/i, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 100) || 'Digital Product';
  }

  function variantIdFromUrl(rawUrl){
    try{
      var parsed = new URL(rawUrl, window.location.href);
      var match = parsed.pathname.match(/\/checkout\/buy\/([^/?#]+)/i);
      return match ? String(match[1]) : '';
    }catch(_){ return ''; }
  }

  function offerType(link){
    var explicit = String(link.getAttribute('data-stwl-offer-type') || '').trim();
    if(explicit) return explicit;
    if(link.closest && link.closest('.stwl-price-card,.stwl-pricing')) return 'subscription';
    if(link.closest && link.closest('.stwl-merch--lab-pack,.stwl-merch')) return 'lab_pack';
    return 'digital_product';
  }

  function publishBeginCheckout(link){
    try{
      if(!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
      var href = String(link.href || link.getAttribute('href') || '');
      var itemName = cleanOfferName(link);
      var type = offerType(link);
      var item = {
        item_id: variantIdFromUrl(href) || itemName.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, ''),
        item_name: itemName,
        item_category: type,
        quantity: 1
      };
      var payload = {
        checkout_provider: 'lemon_squeezy',
        offer_type: type,
        items: [item]
      };
      var rawPrice = String(link.getAttribute('data-stwl-price') || '').trim();
      var price = Number(rawPrice);
      if(rawPrice && isFinite(price) && price >= 0){
        item.price = price;
        payload.value = price;
        payload.currency = String(link.getAttribute('data-stwl-currency') || 'USD').toUpperCase();
      }
      var published = window.Shopify.analytics.publish('spin_wheel_lab:begin_checkout', payload);
      if(published && typeof published.catch === 'function') published.catch(function(){});
    }catch(_){ }
  }

  document.addEventListener('click', function(event){
    if(!event.isTrusted) return;
    var target = event.target;
    var link = target && target.closest ? target.closest('a.lemonsqueezy-button[href*="lemonsqueezy.com/checkout/buy/"]') : null;
    if(!link) return;
    publishBeginCheckout(link);
  }, true);
})();
